import { createRouter, createWebHistory } from '@ionic/vue-router';

const routes = [
  {
    path: '/',
    component: () => import('@/views/Init.vue')
  },
  {
    path: '/preconds',
    component: () => import('@/views/info/PreConds.vue')
  },
  {
    path: '/tabs/main',
    component: () => import('@/views/tabs/1-Main.vue')
  },
  {
    path: '/tabs/live',
    component: () => import('@/views/tabs/2-Live.vue')
  },
  {
    path: '/tabs/results',
    component: () => import('@/views/tabs/3-Results.vue')
  },
  {
    path: '/tabs/stats',
    component: () => import('@/views/tabs/4-Stats.vue')
  },
  {
    path: '/tabs/menu',
    component: () => import('@/views/tabs/5-Menu.vue')
  },
  {
    path: '/register',
    component: () => import('@/views/signup/0-Slides.vue')
  },
  {
    path: '/auth/unlock',
    component: () => import('@/views/auth/Unlock.vue')
  },
  {
    path: '/auth/login',
    component: () => import('@/views/auth/Login.vue')
  },
  {
    path: '/keno',
    component: () => import('@/views/keno/Order.vue')
  },
  {
    path: '/power',
    component: () => import('@/views/power/Order.vue')
  },
  {
    path: '/mega',
    component: () => import('@/views/mega/Order.vue')
  },
  {
    path: '/max3d',
    component: () => import('@/views/max3d/Order.vue')
  },
  {
    path: '/max3dpro',
    component: () => import('@/views/max3dpro/Order.vue')
  },
  {
    path: '/max4d',
    component: () => import('@/views/max4d/Order.vue')
  },
  {
    path: '/xskt',
    component: () => import('@/views/xskt/Order.vue')
  },
  {
    path: '/stats/keno/numbers',
    component: () => import('@/views/stats/1-Keno-numbers.vue')
  },
  {
    path: '/stats/keno/headtail',
    component: () => import('@/views/stats/1-Keno-headtail.vue')
  },
  {
    path: '/stats/keno/hilo',
    component: () => import('@/views/stats/1-Keno-hilo.vue')
  },
  {
    path: '/stats/keno/oddeven',
    component: () => import('@/views/stats/1-Keno-oddeven.vue')
  },
  {
    path: '/stats/keno/advanced',
    component: () => import('@/views/stats/Advanced.vue')
  },
  {
    path: '/stats/power',
    component: () => import('@/views/stats/2-Power.vue')
  },
  {
    path: '/stats/mega',
    component: () => import('@/views/stats/3-Mega.vue')
  },
  {
    path: '/info/contact',
    component: () => import('@/views/info/Contact.vue')
  },
  {
    path: '/info/policy',
    component: () => import('@/views/info/Policy.vue')
  },
  {
    path: '/info/news',
    component: () => import('@/views/info/News.vue')
  },
  {
    path: '/info/pos',
    component: () => import('@/views/info/POS.vue')
  },
  {
    path: '/info/help',
    component: () => import('@/views/info/Help.vue')
  },
  {
    path: '/info/help/mega',
    component: () => import('@/views/info/help/Mega.vue')
  },
  {
    path: '/info/help/power',
    component: () => import('@/views/info/help/Power.vue')
  },
  {
    path: '/info/help/keno',
    component: () => import('@/views/info/help/Keno.vue')
  },
  {
    path: '/info/help/max3d',
    component: () => import('@/views/info/help/Max3d.vue')
  },
  {
    path: '/info/help/max3dpro',
    component: () => import('@/views/info/help/Max3dpro.vue')
  },
  {
    path: '/info/help/max4d',
    component: () => import('@/views/info/help/Max4d.vue')
  },
  {
    path: '/account/deposit/packages',
    component: () => import('@/views/account/deposit/Packages.vue')
  },
  {
    path: '/account/deposit/payment',
    component: () => import('@/views/account/deposit/Payment.vue')
  },
  {
    path: '/account/deposit/bank',
    component: () => import('@/views/account/deposit/Bank.vue')
  },
  {
    path: '/account/withdrawals',
    component: () => import('@/views/account/withdrawals/Withdrawals.vue')
  },
  {
    path: '/account/withdrawals/request/:amount',
    component: () => import('@/views/account/withdrawals/AccList.vue')
  },
  {
    path: '/history/tickets',
    component: () => import('@/views/account/history/Tickets.vue')
  },
  {
    path: '/history/tickets-list/:id',
    component: () => import('@/views/account/history/TicketsList.vue')
  },
  {
    path: '/history/ticket-detail/:id',
    component: () => import('@/views/account/history/TicketDetail.vue')
  },
  {
    path: '/history/transactions',
    component: () => import('@/views/account/history/Transactions.vue')
  },
  {
    path: '/results/keno',
    component: () => import('@/views/result/1-Keno.vue')
  },
  {
    path: '/results/power',
    component: () => import('@/views/result/2-Power.vue')
  },
  {
    path: '/results/mega',
    component: () => import('@/views/result/3-Mega.vue')
  },
  {
    path: '/results/max3d',
    component: () => import('@/views/result/4-Max3D.vue')
  },
  {
    path: '/results/max3dpro',
    component: () => import('@/views/result/7-Max3DPro.vue')
  },
  {
    path: '/results/max4d',
    component: () => import('@/views/result/5-Max4D.vue')
  },
  {
    path: '/results/xskt',
    component: () => import('@/views/result/6-Tranditional.vue')
  },
  {
    path: '/history/transactions',
    component: () => import('@/views/account/history/Transactions.vue')
  },
  {
    path: '/notifications',
    component: () => import('@/views/notifications/NotifyList.vue')
  },
  {
    path: '/account/personal',
    component: () => import('@/views/account/personal/Personal.vue')
  },
  {
    path: '/account/personal/editinfo',
    component: () => import('@/views/account/personal/EditInfo.vue')
  },
  {
    path: '/account/personal/changepin',
    component: () => import('@/views/account/personal/ChangePIN.vue')
  },
  {
    path: '/account/personal/editaddress',
    component: () => import('@/views/account/personal/EditAddress.vue')
  },
  {
    path: '/account/personal/editemail',
    component: () => import('@/views/account/personal/EditEmail.vue')
  },
  {
    path: '/account/personal/verify',
    component: () => import('@/views/account/personal/Verification.vue')
  },
  {
    path: '/account/personal/membership',
    component: () => import('@/views/account/personal/Membership.vue')
  },
  {
    path: '/info/scanticket',
    component: () => import('@/views/info/TicketScanner.vue')
  },
  {
    path: '/account/pointcenter',
    component: () => import('@/views/account/points/PointCenter.vue')
  },
  {
    path: '/account/gamescenter',
    component: () => import('@/views/account/points/GamesCenter.vue')
  },
  {
    path: '/gameplay/fixedbottom',
    component: () => import('@/views/gameplay/FixedBottom.vue')
  },
  {
    path: '/updates/live',
    component: () => import('@/views/updates/Live.vue')
  },
  {
    path: '/updates/native',
    component: () => import('@/views/updates/Native.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

let appInitialized = false;

export const setAppInit = (val) => {
  appInitialized = val;
}

router.beforeEach((to, from, next) => {
  console.log('beforeEach', to);
  if (to.path == '/' || to.path == '/preconds' || to.path == '/info/policy'
    || to.path == '/updates/native' || to.path == '/updates/live') next()
  else if (!appInitialized) { console.log("route blocked, not initialized"); next('/') }
  else next();
})

export default router;

